<template>
  <div v-show="actionButtonTasks.length > 0" class="action-tasks w3-third">
      <div v-for="(taskReqDef) in actionButtonTasks" :key="taskReqDef.id" class="action-button-container">
          <button v-for="(task) in taskReqDef.task" :key="task.taskId"
            class="action-button"
            v-tooltip.top="{content: task.label, delay: { show: 400, hide: 100 } , container: '.action-tasks'}"
            @click="openActionTask(taskReqDef, task)"
          >
            <transition name="fade" mode="out-in">
              <i v-if="!loadingActionTask" :class="getActionButonIcon(task.taskId)"></i>
              <spinner-loading v-else :line-size='2' line-fg-color='#333' class="spinner-loading" />
            </transition>
          </button>
      </div>

      <div class="popup" v-transfer-dom>
        <!-- The Modal -->
        <transition name="fade" mode="out-in">
          <div v-if="isPopupPrinted" :class="['w3-modal', {'w3-hide': !isPopupShow}]" @click.prevent>
            <div class="w3-modal-content action-task">
              <simplebar data-simplebar-auto-hide="false">
                <div class="container">
                  <div>
                    <span class="w3-display-topright close_detail"><i class="sherpa-icon icon-cerrar" @click="popupClose()"></i></span>
                    <div class="w3-container">
                      <div v-if="taskTitle" class="w3-row popup-title">
                        {{ taskTitle }}
                      </div>
                      <div class="action-task-form">
                        <definition-obj
                          :id="reqDef.id"
                          :definitionId="id"
                          :reqDef="reqDef"
                          :reqObj="getRequestObjectById(reqDef.id)"
                          :content="definitionContent"
                          :modeView="type.modeView"
                          :validateForm="validateForm"
                          :validateAddForm="validateAddForm"
                          :repeatableGroupId="getRepeatableGroupId(reqDef)"
                          :languageSelected="languageSelected"
                          :definitionContentId="definitionContentId"
                          :definitionContentCode="definitionContentCode"
                          :requestObjectForAddModified="requestObjectForAddModified"
                          :language="language"
                          :visualDefinition="visualDefinition"
                          :authorization="authorization"
                          :type="type"
                          :visuals="visuals"
                          :apiparams="apiparams"
                          :formAddErrors="formAddErrors"
                          :formAddSaved="formAddSaved"
                          :formAddRemoved="formAddRemoved"
                          :fromActionTask="true"
                          :callTask="callTask"
                          @refreshDefinition="refreshDefinition"
                          @repeatableGroupModified="modifyDefinitionContentRequestObject"
                          @activateValidatingAddForm="activateValidatingAddForm"
                          @deactivateValidatingAddForm="deactivateValidatingAddForm"
                          @errorAddForm="errorAddForm"
                          @errorModifyForm="errorModifyForm"
                          @formAddSaved="addSaved"
                          @newLanguageSelected="newLanguageSelected"
                          @modifyRepeatibleGroup="modifyDefinitionContentRequestObject"
                          @modifyingAddForm="modifyingAddForm"
                          @removingAddForm="removingAddForm"
                          @conditionalDefinitionChange="conditionalDefinitionChange"
                          @refreshDefinitionContent="refreshDefinitionContent"
                          @waitingProcessInit="waitingProcessInit"
                          @taskLink="taskLink"
                          @editingQuestion="editingQuestion"
                          @taskEnded="taskEnded"
                          @callSaveByFieldChange="callSaveByFieldChange"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </simplebar>
            </div>
          </div>
        </transition>
      </div>

      <popup v-if="resultMsg"
        :isPopupShown="resultMsg"
        :title="null"
        :type="null"
        :id="null"
        :txtContent="resultMsg"
        :language="language"
        :authorization="authorization"
        :visuals="visuals"
        :apiparams="apiparams"
        class="action-task-response"
        @popupClose="popupClose"
      />
  </div>
</template>

<script>
import DefinitionObj from '../item/definitionObj'
import transport from 'vue-definition-utils/src/utils/transport'
import simplebar from 'simplebar-vue'
import 'simplebar/dist/simplebar.min.css'
import moment from 'moment'
import Popup from '../popup'

export default {
  name: 'action-task',
  components: {
    simplebar,
    DefinitionObj,
    Popup
  },
  data () {
    return {
      isPopupPrinted: false,
      isPopupShow: false,
      taskTitle: null,
      reqDef: null,
      callTask: null,
      loadingActionTask: false,
      resultMsg: null
    }
  },
  props: [
    'id',
    'requestDefinition',
    'requestObject',
    'definitionContent',
    'visualDefinition',
    'type',
    'validateForm',
    'validateAddForm',
    'languageSelected',
    'definitionContentId',
    'definitionContentCode',
    'requestObjectForAddModified',
    'language',
    'authorization',
    'visuals',
    'apiparams',
    'formAddErrors',
    'formAddSaved',
    'formAddRemoved'
  ],
  methods: {
    isClass (id, classStr) {
      return this.isInClassString(classStr, this.getDefinitionClass(id))
    },
    getDefinitionClass (id) {
      var definition = this.visualDefinition.getDefinitionFields(id)
      return definition.class
    },
    isInClassString (classStr, allClasses) {
      var result = false
      if (allClasses) {
        var classes = allClasses.split(' ')
        if (classes && classes.length > 0) {
          for (var i = 0; i < classes.length && !result; i++) {
            result = (classes[i] === classStr)
          }
        }
      }
      return result
    },
    addActionButtonTasks (requestDefinition) {
      var result = []

      if (requestDefinition) {
        requestDefinition.forEach(reqDef => {
          if (this.isClass(reqDef.id, 'action-button-task')) {
            result.push(reqDef)
          }
          result = result.concat(this.addActionButtonTasks(reqDef.children))
        })
      }

      return result
    },
    getActionButonIcon (id) {
      return 'sherpa-icon icon-' + id
    },
    openActionTask (reqDef, task) {
      this.taskTitle = task.info
      this.reqDef = reqDef
      this.isPopupPrinted = true

      // show popup when reqDef related to the task is editable
      if (transport.methods.isEditable(this.type.modeView, this.reqDef, null)) {
        this.isPopupShow = true
      // if not, call the task directly
      } else {
        this.isPopupShow = false
        this.loadingActionTask = true
        this.$nextTick(() => {
          this.callTask = {
            id: task.taskId,
            ts: moment().valueOf()
          }
        })
      }
    },
    popupClose () {
      this.isPopupPrinted = false
      this.isPopupShow = false
      this.resultMsg = null
    },
    getRequestObjectById (id) {
      return transport.methods.getRequestObjectById(id, this.requestObject)
    },
    getRepeatableGroupId (reqDef) {
      var repeatableGroupId = null
      if (transport.methods.isRepeatableGroup(reqDef)) {
        repeatableGroupId = reqDef.id
      }
      return repeatableGroupId
    },
    refreshDefinition (newReqObj, scope) {
      this.$emit('refreshDefinition', newReqObj, scope)
    },
    modifyDefinitionContentRequestObject (object, callUpdate, code) {
      this.$emit('repeatableGroupModified', object, callUpdate, code)
    },
    activateValidatingAddForm (id, code) {
      this.$emit('activateValidatingAddForm', id, code)
    },
    deactivateValidatingAddForm () {
      this.$emit('deactivateValidatingAddForm')
    },
    errorAddForm (formAddErrors) {
      this.$emit('errorAddForm', formAddErrors)
    },
    errorModifyForm (formModifyErrors) {
      this.$emit('errorModifyForm', formModifyErrors)
    },
    addSaved (code) {
      this.$emit('formAddSaved', code)
    },
    newLanguageSelected (language) {
      this.$emit('newLanguageSelected', language)
    },
    modifyingAddForm (code) {
      this.$emit('modifyingAddForm', code)
    },
    removingAddForm (code, id) {
      this.$emit('removingAddForm', code, id)
    },
    conditionalDefinitionChange (conditionalFieldId, newReqObj) {
      this.$emit('conditionalDefinitionChange', conditionalFieldId, newReqObj)
    },
    refreshDefinitionContent () {
      this.$emit('refreshDefinitionContent')
    },
    waitingProcessInit () {
      this.$emit('waitingProcessInit')
    },
    taskLink (obj) {
      this.$emit('taskLink', obj)
    },
    editingQuestion (editingQuestion) {
      this.$emit('editingQuestion', editingQuestion)
    },
    taskEnded (result) {
      this.loadingActionTask = false
      if (result && result.message) {
        this.resultMsg = result.message
      }
    },
    callSaveByFieldChange (alreadyValidated) {
      this.$emit('callSaveByFieldChange', alreadyValidated)
    }
  },
  computed: {
    actionButtonTasks () {
      return this.addActionButtonTasks(this.requestDefinition)
    }
  },
  watch: {
  }
}
</script>

<style lang="scss">
#sherpaCrmApp {
  #type_actions {
    .action-tasks {
      height: 45px;
      margin-top: 9px;
      padding-left: 70px;

      .action-button-container {
        button.action-button {
          margin-right: 18px;
          padding: 10px;
          height: 45px;
          width: 45px;
          border-radius: 50%;
          background-color: #ff7643;
          float: left;
          outline: none !important;
          border: 0;
          cursor: pointer;

          i {
            color: #000;
            transition: all .2s ease-in;
          }

          &:hover {
            i {
              color: #d42e12;
            }
          }

          .spinner-loading .vue-simple-spinner {
            width: 25px !important;
            height: 25px !important;
          }
        }
      }

      .tooltip {
        .tooltip-inner {
          background: #ff7643 !important;
          color: #000;
        }

        .tooltip-arrow {
          border-color: #ff7643 !important;
        }

        &[x-placement^="top"] {
          margin-bottom: 6px;

          .tooltip-arrow {
            border-width: 5px 5px 0 5px;
            border-left-color: transparent !important;
            border-right-color: transparent !important;
            border-bottom-color: transparent !important;
            bottom: -5px;
            left: calc(50% - 5px);
            margin-top: 0;
            margin-bottom: 0;
          }
        }
      }
    }
  }
}
.popup {
  .w3-modal {
    .w3-modal-content {
      .container {
        padding-bottom: 250px;
      }

      .popup-title {
        text-align: center;
      }

      &.action-task {

        .action-task-form {
          padding: 0 40px 0 46px;

          .definitionObj {
            padding: 0 10px 0 0;

            &.id {
              display: block !important;

              .label,
              .read-only {
                display: none !important;
              }
            }

            .label {
              color: #efefef;
              width: 100%;
            }

            .message {
              .label {
                padding: 0;
                margin-top: 15px;
                font-size: 16px !important;
                font-weight: 400 !important;
                position: initial !important;
                color: #33ff33 !important;

                &.error_validate {
                  color: #99ff33 !important;
                }
              }
            }
          }

          .definition-wrapper {
            .tasks {
              margin-top: 25px;
              text-align: center;
              float: left;
              width: 100%;
            }

            &.text {
              .count {
                color: #efefef;
              }
            }
          }

          .gallery {
            label,
            .taskEval {
              display: none !important;
            }
          }
        }
      }
    }
  }
  &.action-task-response {
    .w3-modal {
      .w3-modal-content {
        top: 23%;
        bottom: 23%;
        right: 20%;
        left: 20%;
        text-align: center;

        .popup-content {
          margin-top: 250px;

          .txtPopup {
            font-size: 22px;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/content/definitionLoader/action/actionTask.vue